import React from "react";
import { Link, useLocation } from "react-router-dom";
import SignIn from "../Tuning/Pages/Authentication/SignIn";
import Signup from "../Tuning/Pages/Authentication/Signup";
import PasswordReset from "../Tuning/Pages/Authentication/PasswordReset";
import TwoStep from "../Tuning/Pages/Authentication/TwoStep";
import Lockscreen from "../Tuning/Pages/Authentication/Lockscreen";
import Maintenance from "../Tuning/Pages/Authentication/Maintenance";
import NoPageFound from "../Tuning/Pages/Authentication/NoPageFound";

const AuthLayout = () => {

  const location = useLocation();
  const pathname = location.pathname;

  const authTitleMapping = {
    "/signin": "Signin",
    "/signup": "Signup",
    "/password-reset": "PasswordReset",
    "/two-step": "TwoStep",
    "/lockscreen": "Lockscreen",
    "/maintenance": "Maintenance",
    "/404": "NoPage",
  };
  const authTitle = authTitleMapping[pathname] || "";

  const authComponents = {
    Signin: <SignIn />,
    Signup: <Signup />,
    PasswordReset: <PasswordReset />,
    TwoStep: <TwoStep />,
    Lockscreen: <Lockscreen />,
    Maintenance: <Maintenance />,
    NoPage: <NoPageFound />,
  };

  return (
    <div data-theme="theme-Bluelight" className="svgstroke-a auth">
      <main className="container px-0">
        <div className="align-items-center justify-content-center d-flex flex-column vh-100">
          <div className="row g-4 justify-content-center align-items-center">

            {/* // x---------------------------------x AuthLayout Page Header Area Section x---------------------------------x */}
            <div className="px-md-5 col-12 px-4 auth-header" data-bs-theme="none">
              <Link to="/" className="brand-icon text-decoration-none d-flex align-items-center justify-content-center"
                title="DashBanker Admin Template">
                <svg className="me-2 text-primary" width="36" height="36" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round"
                  strokeLinejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M3 21l18 0" />
                  <path d="M3 10l18 0" />
                  <path d="M5 6l7 -3l7 3" />
                  <path d="M4 10l0 11" />
                  <path d="M20 10l0 11" />
                  <path d="M8 14l0 3" />
                  <path d="M12 14l0 3" />
                  <path d="M16 14l0 3" />
                </svg>
                <span className="fw-bold ps-2 fs-5 text-gradient">DashBanker</span>
              </Link>
            </div>

            {/* // x---------------------------------x AuthLayout Page Body Area Section x---------------------------------x */}
            <div className="col-12">
              {authComponents[authTitle]}
            </div>

            {/* // x---------------------------------x AuthLayout Footer Body Area Section x---------------------------------x */}
            <footer className="px-xl-5 px-4 mt-3 col-12 text-center">
              <p className="mb-0 text-muted">
                © 2024
                <Link to="/" target="_blank" title="dashbanker">DashBanker</Link>
                , All Rights Reserved.
              </p>
            </footer>
          </div>
        </div>
      </main>

    </div>
  );
};

export default AuthLayout;
